import React from 'react'
import CareerNav from './careerNav'
import { Outlet } from 'react-router-dom'

const CareerParentLayout = () => {
  return (
    <>
            <CareerNav />
    <div className='career-parent-layout'>
       <Outlet/>
    </div>
    </>

  )
}

export default CareerParentLayout